enum InrixVolumeUrlKeys {
  TIME_PERIOD = "timePeriod",
  DAY_OF_WEEK = "dayOfWeek",
  TIME_SEGMENT = "timeSegment",
  TIME_INDEX = "timeIndex",
}

export default InrixVolumeUrlKeys;
